import React from 'react';
import WordRungs from '../games/WordRungs/WordRungs';
import AdPlaceholder from '../components/AdPlaceholder';
import SeoHead from '../components/SeoHead';
import './GamePage.css';

export default function WordRungsPage() {
  return (
    <main className="game-page">
      <SeoHead
        title="Word Rungs"
        description="Word ladder: change one letter per step from start to goal. Daily puzzle for everyone, practice mode, shortest path reveal."
        path="/word-rungs"
      />
      <div className="game-page-ad">
        <AdPlaceholder variant="game-top" />
      </div>
      <WordRungs />
    </main>
  );
}
